const commonConfigs = {
  loop: true,
};

const configs = {
  mobile: {
    autoHeight: true,
    loop: true,
  },
  "quick-view": {
    autoHeight: true,
  },
  "layout-4": {},
  "layout-5": {
    slidesPerView: 1,
    slidesPerGroup: 1,
    watchSlidesProgress: true,
    watchSlidesVisibility: true,
    breakpoints: {
      768: {
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 10,
      },
    },
  },
  "layout-6": {},
  "layout-7": {
    slidesPerView: 3,
    speed: 500,
    centeredSlides: true,
  },
};

const requestDefaultConfigs = {
  mode: "same-origin",
  credentials: "same-origin",
  headers: {
    "X-Requested-With": "XMLHttpRequest",
    "Content-Type": "application/json",
  },
};
class CountdownTimer {
  times = ["day", "hour", "min", "sec"];
  selectors = {
    day: ".countdown-timer-day",
    hour: ".countdown-timer-hour",
    min: ".countdown-timer-minute",
    sec: ".countdown-timer-sec",
  };
  DAY_IN_MS = 24 * 60 * 60 * 1000;
  HOUR_IN_MS = 60 * 60 * 1000;
  MIN_IN_MS = 60 * 1000;

  constructor(container, startTime, endTime, options = {}) {
    this.container = container;
    this.startTime = startTime;
    this.savedStartTime = startTime;
    this.endTime = endTime;
    this.options = Object.assign(
      {},
      {
        addZeroPrefix: true,
        loop: false,
        callback: () => {},
      },
      options
    );

    this.intervalTime = 1000;
    this.timer = null;
    this.domNodes = queryDomNodes(this.selectors, container);

    this.start();
  }

  start = () => {
    this.timer = setInterval(() => {
      if (this.startTime > this.endTime) this.stop();
      else this.update();
    }, this.intervalTime);

    this.container.classList.add("opacity-100");
    this.container.classList.remove("opacity-0");
  };

  update = () => {
    const timeData = this.format(this.endTime - this.startTime);
    this.times.forEach((time) => {
      if (this?.domNodes?.[time]) {
        this.domNodes[time].textContent = this.addZeroPrefix(timeData[time]);
      }
    });
    this.startTime += this.intervalTime;
  };

  stop = () => {
    clearInterval(this.timer);
    if (this.options.loop) {
      this.startTime = this.savedStartTime;
      this.start();
    } else {
      this.timer = null;
      this.options.callback();
    }
  };

  clear = () => {
    clearInterval(this.timer);
    this.timer = null;
    this.startTime = this.savedStartTime;
    this.times.forEach((time) => {
      if (this?.domNodes?.[time]) {
        this.domNodes[time].textContent = "00";
      }
    });
  };

  addZeroPrefix = (num) => {
    if (this?.options?.addZeroPrefix && num < 10) {
      return `0${num}`;
    }
    return num.toString();
  };

  format = (ms) => {
    return {
      day: Math.floor(ms / this.DAY_IN_MS),
      hour: Math.floor(ms / this.HOUR_IN_MS) % 24,
      min: Math.floor(ms / this.MIN_IN_MS) % 60,
      sec: Math.floor(ms / 1000) % 60,
    };
  };
}
window.MinimogTheme.CountdownTimer = CountdownTimer;

class Tabs {
  selectors = {
    tabHeaders: ['.sf-tab-header'],
    tabContents: ['.sf-tab-content']
  }
  activeClass = 'active'
  currentActiveIndex = -1
  currentTab = null

  constructor(container, cb = () => { }) {
    this.container = container
    this.cb = cb
    this.domNodes = queryDomNodes(this.selectors, container)

    this.init()
    this.setActiveTab(0)

    console.log( 'Tabs constructor' )
  }

  init = () => {
    addEventDelegate({
      context: this.container,
      selector: this.selectors.tabHeaders[0],
      handler: (e, tabHeader) => {
        e.preventDefault()
        const index = Number(tabHeader?.dataset?.index)
        this.setActiveTab(index)
        this.cb(tabHeader)
      }
    })
  }

  setActiveTab = (tabIndex) => {
    const { tabHeaders, tabContents } = this.domNodes

    if (tabContents.length && tabIndex !== -1 && this.currentActiveIndex !== tabIndex) {
      const currHeader = tabHeaders?.[this.currentActiveIndex]
      const newHeader = tabHeaders?.[tabIndex]
      const newTab = tabContents?.[tabIndex]

      currHeader?.classList?.remove?.(this.activeClass)
      this.currentTab?.classList?.remove?.(this.activeClass, 'opacity-100')
      this.currentTab?.style?.removeProperty?.('opacity')

      newHeader?.classList?.add?.(this.activeClass)
      newTab?.classList?.add?.(this.activeClass)
      setTimeout(() => newTab.style.opacity = 1)

      this.currentActiveIndex = tabIndex
      this.currentTab = newTab
    }
  }
}

window.MinimogTheme.Tabs = Tabs;

function getRequestDefaultConfigs() {
  return JSON.parse(JSON.stringify(requestDefaultConfigs));
}

function fetchJSON(url, config = getRequestDefaultConfigs()) {
  return fetch(url, config).then(function (response) {
    if (!response.ok) {
      throw response;
    }
    return response.json();
  });
}

const cache = new Map();
function fetchCache(url, config = getRequestDefaultConfigs()) {
  return new Promise((resolve, reject) => {
    let cached = cache.get(url);
    if (cached) return resolve(cached);
    fetch(url, config)
      .then((res) => {
        cached = res.text();
        cache.set(url, cached);
        resolve(cached);
      })
      .catch(reject);
  });
}

const sectionCache = new Map();
function fetchSection(sectionId, options = {}) {
  const { url: _url, fromCache = false, params = {} } = options;
  return new Promise((resolve, reject) => {
    const url = new URL(_url || window.location.href);
    url.searchParams.set("section_id", sectionId);
    Object.entries(params).forEach(([k, v]) => url.searchParams.set(k, v));

    if (fromCache) {
      const cached = sectionCache.get(url);
      if (cached) return resolve(cached);
    }

    fetch(url, getRequestDefaultConfigs())
      .then((res) => {
        if (res.ok) return res.text();
        reject(`Failed to load section: ${sectionId}`);
      })
      .then((html) => {
        const div = generateDomFromString(html);
        sectionCache.set(url, div);
        resolve(div);
        // const div = <div />
        // div.innerHTML = html
        // sectionCache.set(url, div)
        // resolve(div)
      })
      .catch(reject);
  });
}

const cache2 = new Map();
function fetchJsonCache(url, config = requestDefaultConfigs) {
  return new Promise((resolve, reject) => {
    if (cache2.get(url)) {
      return resolve(cache2.get(url));
    }
    fetch(url, config)
      .then((res) => {
        if (res.ok) {
          const json = res.json();
          resolve(json);
          cache2.set(url, json);
          return json;
        } else {
          reject(res);
        }
      })
      .catch(reject);
  });
}

function formatMoney(cents, format) {
  const moneyFormat = "${{amount}}";
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  let value = "";
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || moneyFormat;

  function formatWithDelimiters(number, precision = 2, thousands = ",", decimal = ".") {
    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split(".");
    const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
    const centsAmount = parts[1] ? decimal + parts[1] : "";

    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
}

function validateForm(form) {
  const missingFields = [];
  if (!form) return missingFields;
  const fieldSelectors = '[data-product-custom-field] [name][required]:not([hidden]):not([type="hidden"])';
  const requiredFields = form.querySelectorAll(fieldSelectors);
  requiredFields.forEach((field) => {
    field.classList.remove("form-control--warning");
    if (field.type === "radio") {
      const buttons = form.querySelectorAll(`input[name="${field.name}"]`);
      const selected = Array.from(buttons).some((btn) => btn.checked);
      if (!selected) {
        missingFields.push(field);
        field.classList.add("form-control--warning");
      }
    } else if (!field.value) {
      missingFields.push(field);
      field.classList.add("form-control--warning");
    }
  });
  return missingFields;
}

function generateDomFromString(value, tagName = "div") {
  const d = document.createElement(tagName);
  d.innerHTML = value;
  return d;
}

function generateDomeFromStringNew(value, selector = "div") {
  const dom = new DOMParser().parseFromString(value, "text/html");
  const newDom = dom.querySelector(selector);
  return newDom;
}

function fetchCountDown(collectionID) {
  const appURL = MinimogSettings.foxkitAppURL ? `https://${MinimogSettings.foxkitAppURL}` : "";

  return new Promise((resolve, reject) => {
    let requestUrl = `${appURL}/api/public/countdown?shop=${window.Shopify?.shop}&collectionIds=${collectionID}`;

    fetch(requestUrl)
      .then((response) => response.json())
      .then(resolve)
      .catch(reject);
  });
}

function loadAssetsNew(files = [], id, callback = () => {}, options = {}) {
  const unique = id ? id : Math.random().toString(36).slice(2);
  if (!window.MinimogLibs.loadjs.isDefined(id)) window.MinimogLibs.loadjs(files, unique);
  window.MinimogLibs.loadjs.ready(unique, callback);
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + "pauseVideo" + '","args":""}', "*");
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function getProductSliderConfig(layout) {
  const conf = configs[layout] || configs["layout-4"];
  return Object.assign({}, commonConfigs, conf);
}

function loadJS(src, target = document.body, async = false, defer = true) {
  return new Promise((resolve, reject) => {
    const doc = target.ownerDocument;
    const currScript = doc.querySelector(`script[src="${src}"]`);
    if (currScript) {
      if (currScript.dataset.loaded) return resolve(true);
      currScript.addEventListener("load", () => {
        currScript.dataset.loaded = true;
        resolve(true);
      });
      return;
    }
    const script = doc.createElement("script");
    script.src = src;
    script.async = async;
    script.defer = defer;
    script.addEventListener("load", () => {
      script.dataset.loaded = true;
      resolve(true);
    });
    script.onerror = reject;
    target.appendChild(script);
  });
}

function loadCSS(href, target = document.head) {
  return new Promise((resolve, reject) => {
    const doc = target.ownerDocument;
    const currLink = doc.querySelector(`link[href="${href}"]`);
    if (currLink) {
      if (currLink.dataset.loaded) return resolve(true);
      currLink.addEventListener("load", () => {
        currLink.dataset.loaded = true;
        resolve(true);
      });
      return;
    }
    const link = doc.createElement("link");
    link.rel = "stylesheet";
    link.href = href;
    link.addEventListener("load", () => {
      link.dataset.loaded = true;
      resolve(true);
    });
    link.onerror = reject;
    target.appendChild(link);
  });
}

function addEventDelegate({ context = document.documentElement, event = "click", selector, handler, capture = false }) {
  const listener = function (e) {
    // loop parent nodes from the target to the delegation node
    for (let target = e.target; target && target !== this; target = target.parentNode) {
      if (target.matches(selector)) {
        handler.call(target, e, target);
        break;
      }
    }
  };
  context.addEventListener(event, listener, capture);
  return () => {
    context.removeEventListener(event, listener, capture);
  };
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function createSearchLink(query) {
  const searchParams = new URLSearchParams({
    type: 'product',
    ['options[unavailable_products]']: 'last',
    ['options[prefix]']: 'last',
    q: query
  })

  const searchURL = window.MinimogSettings.routes.search_url
  return `${searchURL}?${searchParams.toString()}`
}

const { themeScriptURLs, themeStyleURLs } = window;
if (!themeScriptURLs || !themeStyleURLs) console.warn("Missing Assest URLs source");
const themeAssets = {
  js: {
    urls: themeScriptURLs,
    load: loadJS,
  },
  css: {
    urls: themeStyleURLs,
    load: loadCSS,
  },
};

function log(asset) {
  console.groupCollapsed("%c Asset loaded: ", "#f7a046", asset);
  console.trace();
  console.groupEnd();
}

function loadAssets(param, ...rest) {
  return new Promise((resolve, reject) => {
    const files = typeof param === "string" ? [param] : param;
    Promise.all(
      files.map(async (file) => {
        try {
          const [, name, type] = file.match(/(.*)\.(js|css)$/) || [, file, "js"];
          const {
            urls: {
              [name]: { url },
            },
            load,
          } = themeAssets[type];
          await load(url, ...rest);
          log(`${name}.${type}`);
        } catch (err) {
          console.warn(`Failed to load asset: ${file}.`, err);
        }
      })
    )
      .then(resolve)
      .catch(reject);
  });
}

function queryDomNodes(selectors = {}, context = document) {
  const domNodes = Object.entries(selectors).reduce((acc, [name, selector]) => {
    const findOne = typeof selector === "string";
    const queryMethod = findOne ? "querySelector" : "querySelectorAll";
    const sl = findOne ? selector : selector[0];

    acc[name] = context?.[queryMethod]?.(sl);
    if (!findOne && acc[name]) {
      acc[name] = [...acc[name]];
    }
    return acc;
  }, {});
  return domNodes;
}

function saleProgress(settings, productId, soldNumber) {
  const { total_quantity, sold_to, sold_from } = settings;
  let soldNumb;
  // const hour = new Date().getHours()
  if (soldNumber) {
    soldNumb = parseInt(soldNumber);
  } else {
    const hour = 4;
    const range = sold_to - sold_from;
    const timeRatio = hour / 24;
    const randomRatioById = (Number(productId.split("").pop()) + 1) / 10;
    let combinedRatio = timeRatio + randomRatioById;
    if (combinedRatio > 1) combinedRatio -= 1;

    const delta = Math.ceil(combinedRatio * range);
    soldNumb = sold_from + delta;
  }

  const availableNumb = total_quantity - soldNumb;
  const progress = (soldNumb * 100) / total_quantity;

  return `
    <div class="pcard-sale">
      <div class="pcard-sale__progress" data-flash-sale>
        <span data-sale-progress style="width: ${progress}%;" />
      </div>
      <div class="pcard-sale__text flex justify-between mt-2">
        <div>
          <span>${MinimogStrings.sold}: </span>
          <strong data-sale-number>${soldNumb || 0}</strong>
        </div>
        <div>
          <span>${MinimogStrings.available}: </span>
          <strong data-available-number>${availableNumb || 0}</strong>
        </div>
      </div>
    </div>
  `;
}

function spinner(className = "") {
  return `<svg class="animate-spin hidden w-[20px] h-[20px] ${className}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
  </svg>`;
}

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    const autoPlay = this.dataset.autoPlay === "true";
    if (!autoPlay) window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(true));

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(content.querySelector("video, model-viewer, iframe"));
      this.deferredElement = deferredElement;

      if (focus) deferredElement.focus();
    }
  }
}
customElements.define("deferred-media", DeferredMedia);
class ResponsiveImage extends HTMLElement {
  get intersecting() {
    return this.hasAttribute("intersecting");
  }
  constructor() {
    super();
    this.img = this.querySelector("img");
    this.observerCallback = this.observerCallback.bind(this);
    this.loadImage = this.loadImage.bind(this);
    this.img.onload = this.onLoad.bind(this);
  }
  connectedCallback() {
    if ("IntersectionObserver" in window) this.initIntersectionObserver();
    else this.loadImage();
  }
  disconnectedCallback() {
    this.disconnectObserver();
  }
  loadImage() {
    this.setAttribute("intersecting", "true");
    this.img.width = this.clientWidth;
    this.img.height = this.clientHeight;
    this.img.sizes = this.clientWidth + "px";
  }
  onLoad() {
    this.removeAttribute("data-image-loading");
    this.img.classList.add("f-img-loaded");
  }
  observerCallback(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);
    this.loadImage();
  }
  initIntersectionObserver() {
    if (this.observer) return;
    const rootMargin = "10px";
    this.observer = new IntersectionObserver(this.observerCallback, { rootMargin });
    this.observer.observe(this);
  }
  disconnectObserver() {
    if (!this.observer) return;
    this.observer.disconnect();
    this.observer = null;
    delete this.observer;
  }
}
customElements.define("responsive-image", ResponsiveImage);
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.productId = this.dataset.productId;

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );

    this.input.addEventListener("change", () => {
      window.MinimogEvents.emit(`${this.productId}__QUANTITY_CHANGE`, this.input.value, this);
    });
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    console.log("quantity-input", previousValue, this.input, event.target.closest("button").getAttribute("name"));

    event.target.closest("button").getAttribute("name") === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}
customElements.define("quantity-input", QuantityInput);
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = generateDomFromString(text);
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
            const sliderContainer = this.querySelector(".swiper-container");
            const dataItemsPerPage = this.dataset.itemsPerPage;
            if (sliderContainer) {
              let slider;
              loadAssets(["swiper.css", "swiper.js"]).then(() => {
                slider = new MinimogLibs.Swiper(sliderContainer, {
                  slidesPerView: 2,
                  loop: true,
                  autoplay: false,
                  autoHeight: true,
                  breakpoints: {
                    1280: {
                      slidesPerView: dataItemsPerPage,
                    },
                  },
                });

                if (slider) {
                  const prevBtn = this.querySelector(".sf-slider__controls-prev");
                  const nextBtn = this.querySelector(".sf-slider__controls-next");
                  prevBtn && prevBtn.addEventListener("click", () => slider.slidePrev());
                  nextBtn && nextBtn.addEventListener("click", () => slider.slideNext());
                }
              });
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };
    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: "0px 0px 400px 0px" }).observe(this);
  }
}
customElements.define("product-recommendations", ProductRecommendations);

if (!customElements.get("video-component")) {
  customElements.define(
    "video-component",
    class VideoComponent extends DeferredMedia {
      constructor() {
        super();
        this.autoplay = this?.dataset.autoPlay === "true";
        this.coverImage = this?.dataset.coverImage === "true";
        if (this.autoplay || !this.coverImage) this.loadContent();
      }

      loadContent() {
        super.loadContent();

        // Autoplay after click on poster
        if (!this.autoplay && this.coverImage) {
          const iframeSrc = this.deferredElement?.getAttribute("src");
          const symbol = iframeSrc?.indexOf("?") > -1 ? "&" : "?";
          if (iframeSrc) this.deferredElement.setAttribute("src", iframeSrc + symbol + "autoplay=1");
        }
      }
    }
  );
}

if (!customElements.get("collapsible-tab")) {
  class CollapsibleTab extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
    }

    disconnectedCallback() {
      this.destroy();
    }

    init = () => {
      const destroy = this.dataset.destroy === "true";
      if (destroy) return;

      this.setDefaultData();
      this.attachEvents();

      if (this.getAttribute("open") === "true") {
        this.selected = true;
        this.classList.add(this.expandedClass);
        this.setExpandedAria();
      } else {
        this.content.style.height = this.collapsedHeight;
        this.classList.add(this.collapsedClass);
        this.setCollapsedAria();
      }
      this.content.removeAttribute("hidden");
    };

    transitionendEventName = () => {
      let i,
        el = document.createElement("div"),
        transitions = {
          transition: "transitionend",
          OTransition: "otransitionend",
          MozTransition: "transitionend",
          WebkitTransition: "webkitTransitionEnd",
        };

      for (i in transitions) {
        if (transitions.hasOwnProperty(i) && el.style[i] !== undefined) {
          return transitions[i];
        }
      }
    };

    expand = () => {
      const resetHeight = (ev) => {
        if (ev.target !== this.content) return;
        this.content.removeEventListener(this.transitionendevent, bindEvent);

        if (!this.isOpen) return;

        requestAnimationFrame(() => {
          this.content.style.transition = "0";
          this.content.style.height = "auto";

          requestAnimationFrame(() => {
            this.content.style.height = null;
            this.content.style.transition = null;

            this.setExpandedAria();
            this.classList.add(this.expandedClass);
            this.trySetTabIndex(this.content, 0);

            this.fire("tabOpened");
          });
        });
      };

      const bindEvent = resetHeight.bind(this);
      this.content.addEventListener(this.transitionendevent, bindEvent);

      this.isOpen = true;
      this.classList.remove(this.collapsedClass);
      this.content.style.height = this.content.scrollHeight + "px";
    };

    collapse = () => {
      const endTransition = (ev) => {
        if (ev.target !== this.content) return;
        this.content.removeEventListener(this.transitionendevent, bindEvent);

        if (this.isOpen) return;

        this.fire("elementClosed");
        this.setCollapsedAria();
        this.classList.add(this.collapsedClass);
        this.trySetTabIndex(this.content, -1);
      };

      const bindEvent = endTransition.bind(this);
      this.content.addEventListener(this.transitionendevent, bindEvent);

      this.isOpen = false;
      this.classList.remove(this.expandedClass);

      requestAnimationFrame(() => {
        this.content.style.transition = "0";
        this.content.style.height = this.content.scrollHeight + "px";

        requestAnimationFrame(() => {
          this.content.style.transition = null;
          this.content.style.height = this.collapsedHeight;
        });
      });
    };

    open = () => {
      this.selected = true;
      this.fire("elementSelected");
      this.expand();
      this.setAttribute("open", true);
      console.log("elementSelected");
    };

    close = () => {
      console.log("elementUnselected");
      this.selected = false;
      this.fire("elementUnselected");
      this.collapse();
      this.removeAttribute("open");
    };

    toggle = (event) => {
      event?.preventDefault();
      if (this.selected) {
        this.close();
      } else {
        this.open();

        if (this.oneAtATime) {
          const allItems = document.querySelectorAll("collapsible-tab");
          const parent = this.closest("[data-first-level]");
          if (allItems.length) {
            allItems.forEach((item) => {
              if (item !== this && item.selected && parent !== item) {
                item.close();
              }
            });
          }
        }
      }
    };

    trySetTabIndex(el, index) {
      const tappableElements = el.querySelectorAll(this.defaultElements);
      if (tappableElements) {
        tappableElements.forEach((e) => {
          e.setAttribute("tabindex", index);
        });
      }
    }

    setExpandedAria = () => {
      this.trigger.setAttribute("aria-expanded", "true");
      this.content.setAttribute("aria-hidden", "false");
    };

    setCollapsedAria = (el) => {
      this.trigger.setAttribute("aria-expanded", "false");
      this.content.setAttribute("aria-hidden", "true");
    };

    attachEvents = () => {
      this.trigger.addEventListener("click", (event) => this.toggle(event));
    };

    setDefaultData = () => {
      this.events = {
        elementSelected: [],
        tabOpened: [],
        elementUnselected: [],
        elementClosed: [],
      };
      this.transitionendevent = this.transitionendEventName();
      this.expandedClass = "is-expanded";
      this.collapsedClass = "is-collapsed";
      this.trigger = this.querySelector("[data-trigger]");
      this.content = this.querySelector("[data-content]");
      this.collapsedHeight = "0px";
      this.defaultElements = ["a", "button", "input:not(.focus-none)", "[data-trigger]"];
      this.oneAtATime = true;
      if (this.dataset.oneOpen) {
        this.oneAtATime = this.dataset.oneOpen === "true";
      }
    };

    fire = (eventName) => {
      let callbacks = this.events[eventName];
      for (let i = 0; i < callbacks?.length; i++) {
        callbacks[i](this);
      }
    };

    on = (eventName, cb) => {
      if (!this.events[eventName]) return;
      this.events[eventName].push(cb);
    };

    destroy = () => {
      this.trigger.removeEventListener("click", (event) => this.toggle(event));
      this.content.removeAttribute("aria-hidden");
      this.content.style.height = "auto";
      this.classList.remove(this.expandedClass, this.collapsedClass);
      this.removeAttribute("open");
    };
  }

  customElements.define("collapsible-tab", CollapsibleTab);
}

if (!customElements.get("m-slideshow")) {
  class MSlideshow extends HTMLElement {
    constructor() {
      super();

      this.autoplay = this.dataset.autoplay === "true";
      this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed);
      this.showArrows = this.dataset.enableArrows === "true";
      this.showDots = this.dataset.enableDots === "true";
      this.adaptHeight = this.dataset.slideHeight === "adapt";
      this.id = this.dataset.id;

      this.lastVideo = null;
      this.lastActive = null;
      this.timeout = null;
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      const selectors = {
        slideContent: ".sf__slide-content",
      };
      const paginationIcon = `<svg width="65px" height="65px" viewBox="0 0 72 72" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><circle class="time" stroke-width="5" fill="none" stroke-linecap="round" cx="33" cy="33" r="28"></circle></svg>`;
      loadAssets(["swiper.css", "swiper.js"])
        .then(() => {
          this.slider = new MinimogLibs.Swiper(`#sf-slider-${this.id}`, {
            init: false,
            autoplay: this.autoplay
              ? {
                  delay: this.autoplaySpeed * 1000,
                  disableOnInteraction: true,
                }
              : false,
            slidesPerView: 1,
            slidesPerGroup: 1,
            loop: true,
            effect: "fade",
            fadeEffect: {
              crossFade: true,
            },
            speed: 1000,
            navigation: this.showArrows
              ? {
                  nextEl: this.querySelector(".sf-slider__controls-next"),
                  prevEl: this.querySelector(".sf-slider__controls-prev"),
                }
              : false,
            pagination: this.showDots
              ? {
                  el: this.querySelector(".swiper-pagination"),
                  clickable: true,
                  bulletClass: "sf__dot",
                  bulletActiveClass: "sf__dot-active",
                  renderBullet: function (index, className) {
                    return '<span class="' + className + '">' + paginationIcon + "</span>";
                  },
                }
              : false,
            breakpoints: {
              992: {
                // allowTouchMove: false
                threshold: 2,
              },
            },
          });

          this.lastSlide = null;
          this.currentSlide = null;

          this.slider &&
            this.slider.on("slideChangeTransitionStart", () => {
              this.lastSlide && this.lastSlide.classList.remove("slide-in");
              this.lastSlide && this.lastSlide.classList.add("slide-out");
            });

          this.slider &&
            this.slider.on("slideChangeTransitionEnd", ({ activeIndex, slides }) => {
              const currentSlide = slides[activeIndex];
              this.currentSlide = currentSlide.querySelector(selectors.slideContent);
              this.currentSlide && this.currentSlide.classList.add("slide-in");

              this.lastSlide && this.lastSlide.classList.remove("slide-out", "slide-in");

              this.lastSlide = this.currentSlide;
            });
          this.slider && this.slider.on("init", this.handleChange.bind(this));
          this.slider && this.slider.on("slideChange", this.handleChange.bind(this));
          this.slider.init();
        })
        .catch(console.error);

      document.addEventListener("shopify:block:select", (e) => this.onBlockSelect(e));
    }

    handleChange(swiper) {
      const { activeIndex, slides } = swiper;
      const slideType = slides[activeIndex]?.dataset.slideType;
      this.lastActive && this.slider.slideToLoop(this.lastActive);
      if (slideType === "video_slide") {
        const video = slides[activeIndex].querySelector("video");

        if (video) {
          let playPromise = video.play();
          this.lastVideo && this.lastVideo.pause();
          if (playPromise !== undefined) {
            playPromise.then(() => {
              this.lastVideo = video;
            });
          }
        }
      } else {
        this.lastVideo && this.lastVideo.pause();
        this.lastVideo = null;
      }
    }

    setSlideshowHeight() {
      const minAspectRatio = this.dataset.minAspectRatio;
      const slideHeight = document.documentElement.offsetWidth / minAspectRatio + "px";
      // console.log(slideHeight, 'slideHeight')
    }

    onBlockSelect(ev) {
      const block = ev.target;
      const index = Number(block.dataset.slide);
      this.lastActive = index;
      this.slider?.slideToLoop?.(index);
    }
  }

  customElements.define("m-slideshow", MSlideshow);
}
if (!customElements.get("m-testimonials")) {
  class MTestimonials extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.design = this?.dataset?.design;
      const containerType = this?.dataset?.container;
      const autorotate = this?.dataset?.autoplay === "true";
      this.container = this.closest('.sf-testimonials');

      if (!this.design) {
        return console.warn("Failed to init Testimonials: design not found!!");
      }

      this.sliderContainer = this.querySelector(".swiper-container");
      if (!this.sliderContainer) {
        this.classList.add("opacity-100");
        return;
      }

      this.defaultSettings = {
        pagination: {
          el: this.container.querySelector(".swiper-pagination"),
          clickable: true,
        },
        navigation: {
          nextEl: this.container.querySelector(".sf-slider__controls-next"),
          prevEl: this.container.querySelector(".sf-slider__controls-prev"),
        },
        autoHeight: true,
        autoplay: autorotate
          ? {
              delay: 5000,
              pauseOnMouseEnter: false,
            }
          : false,
        loop: true,
        slidesPerView: 1,
      };

      this.settings = {};
      let gutter = 400;
      switch (this.design) {
        case "testimonials-1":
          this.settings = {
            centeredSlides: true,
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 20,
            speed: 300,
            slideToClickedSlide: true,
            loop: true,
            breakpoints: {
              768: {
                slidesPerView: 3,
                slidesPerGroup: 3,
                spaceBetween: 20,
                speed: 1000,
              },
              1280: {
                slidesPerView: 5,
                slidesPerGroup: 3,
                spaceBetween: 30,
              },
              2560: {
                slidesPerView: 7,
                slidesPerGroup: 3,
              },
            },
          };
          break;
        case "testimonials-2":
          this.settings = {
            slidesPerView: 1,
            spaceBetween: 30,
            breakpoints: {
              768: { slidesPerView: 3, slidesPerGroup: 3 },
            },
          };
          break;
        case "testimonials-3":
          this.settings = {
            slidesPerView: 1,
            spaceBetween: 30,
            breakpoints: {
              768: { slidesPerView: containerType === "w-full" ? 3 : 2 },
            },
          };
          break;
        case "testimonials-4":
          if (containerType === "container-fluid") gutter = 200;
          if (containerType === "container") gutter = 150;
          this.settings = {
            slidesPerView: 1,
            centeredSlides: true,
            slideToClickedSlide: true,
            breakpoints: {
              768: { spaceBetween: parseInt(gutter / 4), slidesPerView: 3 },
              992: { spaceBetween: gutter / 2, slidesPerView: 3 },
              1920: { spaceBetween: gutter, slidesPerView: 3 },
            },
          };
          break;
        case "testimonials-6":
          this.settings = {
            slidesPerView: 1,
            loop: true,
            breakpoints: {
              768: { slidesPerView: 2 },
              1366: { slidesPerView: containerType === "container" ? 2 : 3 },
              1600: { slidesPerView: containerType === "container" ? 2 : 4 },
            },
          };
          break;
        case "testimonials-5":
          this.settings = {
            fade: {
              crossFade: true,
            },
          };
          break;
      }

      // Testimonials 5
      const images = this.querySelector(".sf-tabs");
      if (images) {
        const interval = setInterval(() => {
          if (MinimogTheme.Tabs) {
            clearInterval(interval);
            this.imagesTab = new MinimogTheme.Tabs(images);
          }
        }, 50);
      }

      this.initSlider();
    }

    initSlider() {
      loadAssets(["swiper.css", "swiper.js"]).then(() => {
        this.slider = new MinimogLibs.Swiper(this.sliderContainer, { ...this.defaultSettings, ...this.settings });
        if (this.design === "testimonials-4") {
          this.slider.on("activeIndexChange", (swiper) => {
            const { realIndex } = swiper;
            this.querySelector(".sf-slider-index").innerHTML = parseInt(realIndex) + 1;
          });
        }
        if (this.design === "testimonials-5") {
          this.slider.on("slideChange", (swiper) => {
            const { realIndex } = swiper;
            this.imagesTab.setActiveTab(realIndex);
          });
        }
      });

      document.addEventListener("shopify:block:select", (e) => this.onBlockSelect(e));
    }

    onBlockSelect(ev) {
      const block = ev.target;
      const index = Number(block.dataset.index);
      this?.slider?.slideToLoop?.(index);
    }
  }

  customElements.define("m-testimonials", MTestimonials);
}

if (!customElements.get("m-collection-list")) {
  class MCollectionList extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.enableSlider = this.dataset.enableSlider === "true";
      this.sliderContainer = this.querySelector(".swiper-container");
      this.items = this.dataset.items;
      this.autoplay = this.dataset.autoplay === "true";
      this.autoplaySpeed = this.dataset.autoplaySpeed;

      this.initSlider();
    }

    initSlider() {
      const paginationIcon = `<svg width="65px" height="65px" viewBox="0 0 72 72" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><circle class="time" stroke-width="5" fill="none" stroke-linecap="round" cx="33" cy="33" r="28"></circle></svg>`;
      loadAssets(["swiper.css", "swiper.js"]).then(() => {
        this.slider = new MinimogLibs.Swiper(this.sliderContainer, {
          slidesPerView: 2,
          loop: true,
          slidesPerGroup: 1,
          showNavigation: true,
          showPagination: true,
          parallax: true,
          autoplay: this.autoplay
            ? {
                delay: parseInt(this.autoplaySpeed) * 1000,
              }
            : false,
          pagination: {
            el: this.querySelector(".swiper-pagination"),
            clickable: true,
            bulletClass: "sf__dot",
            bulletActiveClass: "sf__dot-active",
            renderBullet: function (index, className) {
              return '<span class="' + className + '">' + paginationIcon + "</span>";
            },
          },
          autoHeight: true,
          breakpoints: {
            480: {
              slidesPerView: 3,
              slidesPerGroup: 2,
            },
            768: {
              slidesPerView: 4,
              slidesPerGroup: 2,
            },
            1280: {
              slidesPerView: parseInt(this.items) + 1,
              slidesPerGroup: this.autoplay ? 1 : 2,
            },
          },
        });

        const controlsContainer = this.querySelector(".sf-slider__controls");
        const prevButton = controlsContainer && controlsContainer.querySelector(".sf-slider__controls-prev");
        const nextButton = controlsContainer && controlsContainer.querySelector(".sf-slider__controls-next");

        if (this.slider && prevButton && nextButton) {
          prevButton && prevButton.addEventListener("click", () => this.slider.slidePrev());
          nextButton && nextButton.addEventListener("click", () => this.slider.slideNext());
        }
      });
    }
  }

  customElements.define("m-collection-list", MCollectionList);
}

if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.selectors = {
          form: "form",
          inputId: "[name=id]",
          submitButton: '[name="add"]',
          errorWrapper: ".prod__form-error",
          customFields: ["[data-product-custom-field]"],
          dynamicCheckout: ".prod__dynamic_checkout",
        };

        this.domNodes = queryDomNodes(this.selectors, this);

        this.form = this.domNodes.form;
        this.submitButton = this.domNodes.submitButton;
        this.domNodes.inputId.disabled = false;
        this.notificationType = this.dataset.notificationType;
        this.customFields = document.querySelectorAll(this.selectors.customFields);
        if (this.domNodes.dynamicCheckout) this.enable_dynamic_checkout = true;

        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));

        if (this.domNodes.dynamicCheckout && this.customFields) {
          this.domNodes.dynamicCheckout.addEventListener(
            "click",
            (e) => {
              const missing = validateForm(this.form.closest(".main-product__blocks"));
              if (missing.length > 0) {
                e.stopPropagation();
                window.MinimogTheme.Notification.show({
                  target: this.domNodes.errorWrapper,
                  method: "appendChild",
                  type: "warning",
                  message: window.MinimogStrings.requiredField,
                  delay: 100,
                });
                console.warn("Missing field(s): ", missing);
              }
            },
            true
          );
        }
      }

      toggleSpinner = (show) => {
        const method = show ? "add" : "remove";
        this.form.closest(".product-form").classList[method]("adding");
      };

      onSubmitHandler(evt) {
        evt.preventDefault();
        this.toggleSpinner(true);
        const missing = validateForm(this.form.closest(".main-product__blocks"));

        if (missing?.length > 0) {
          console.warn("Missing field(s): ", missing);
          this.toggleSpinner(false);
          return window.MinimogTheme.Notification.show({
            target: this?.domNodes?.errorWrapper,
            method: "appendChild",
            type: "warning",
            message: window.MinimogStrings.requiredField,
          });
        }

        const config = {
          method: "POST",
          headers: {
            Accept: "application/javascript",
            "X-Requested-With": "XMLHttpRequest",
          },
        };

        const formData = new FormData(this.form);
        config.body = formData;
        const { MinimogSettings, MinimogStrings } = window;
        if (MinimogSettings.use_ajax_atc) {
          fetch(`${MinimogSettings.routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                return window.MinimogTheme.Notification.show({
                  target: this.notificationType === "toast" ? document.body : this.domNodes.errorWrapper,
                  method: "appendChild",
                  type: "warning",
                  message: response.description,
                  last: 3000,
                  sticky: this.notificationType === "toast",
                });
              }

              if (!MinimogSettings.enable_cart_drawer) {
                window.MinimogTheme.Notification.show({
                  target: this.domNodes.errorWrapper,
                  method: "appendChild",
                  type: "success",
                  message: window.MinimogStrings.itemAdded,
                  last: 3000,
                  sticky: this.notificationType === "toast",
                });
              }
              window.MinimogEvents.emit(`ON_ITEM_ADDED`, response);
              window.Shopify.onItemAdded(response, MinimogSettings.enable_cart_drawer);
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.toggleSpinner(false);
            });
        } else {
          this.form.submit();
        }
      }
    }
  );
}

if (!customElements.get("m-press")) {
  class MPress extends HTMLElement {
    constructor() {
      super();
      this.prevSlideIndex = 0;
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      loadAssets(["swiper.css", "swiper.js"])
        .then(() => {
          const contentWrapper = this.querySelector(".press-content");
          const navWrapper = this.querySelector(".press-list .swiper-container");
          const autoplay = this.dataset.autoplay === "true";

          this.items = parseInt(this.dataset.items);
          this.canLoop = window.innerWidth < 1300 ? this.items > 3 : this.items > 5;

          this.contentSlider = new MinimogLibs.Swiper(contentWrapper, {
            slidesPerView: 1,
            allowTouchMove: false,
            fadeEffect: {
              crossFade: true,
            },
          });

          this.navSlider = new MinimogLibs.Swiper(navWrapper, {
            autoplay: autoplay
              ? {
                  delay: 5000,
                }
              : false,
            items: 1,
            loop: this.canLoop,
            centeredSlides: this.canLoop,
            threshold: 2,
            pagination: {
              el: this.querySelector(".swiper-pagination"),
              clickable: true,
            },
            slideToClickedSlide: true,
            breakpoints: {
              768: {
                slidesPerView: 3,
                navigation: false,
              },
              1280: {
                slidesPerView: 5,
                navigation: false,
              },
            },
            on: {
              init: function (swiper) {
                const firstSlide = swiper.slides[swiper.activeIndex];
                firstSlide && firstSlide.classList.add("press-logo--active");
              },
            },
          });

          !this.canLoop && this.navSlider.on("click", this._handleClick.bind(this));
          this.navSlider.on("slideChange", this._handleChange.bind(this));
        })
        .catch(console.error);

      document.addEventListener("shopify:block:select", (e) => this.onBlockSelect(e));
    }

    _handleChange(swiper) {
      const { realIndex, activeIndex, slides } = swiper || {};

      const prevSlide = this.querySelector('.press-logo--active[data-index="' + this.prevSlideIndex + '"]');
      const currentSlide = slides[activeIndex];

      currentSlide && currentSlide.classList.add("press-logo--active");
      prevSlide && prevSlide.classList.remove("press-logo--active");

      // Change content slide
      this.contentSlider.slideTo(realIndex);
      // Set prev slide index
      this.prevSlideIndex = realIndex;
    }

    _handleClick(swiper) {
      const { clickedIndex, clickedSlide } = swiper || {};

      const prevSlide = this.querySelector('.press-logo--active[data-index="' + this.prevSlideIndex + '"]');

      clickedSlide && clickedSlide.classList.add("press-logo--active");
      prevSlide && prevSlide.classList.remove("press-logo--active");

      // Change content slide
      this.contentSlider.slideTo(clickedIndex);
      // Set prev slide index
      this.prevSlideIndex = clickedIndex;
    }

    onBlockSelect(evt) {
      const block = evt.target;
      const index = Number(block.dataset.index);
      this?.contentSlider?.slideTo?.(index);
      this?.navSlider?.slideTo?.(index);
    }
  }

  customElements.define("m-press", MPress);
}

if (!customElements.get("m-featured-slider")) {
  class MFeaturedSlider extends HTMLElement {
    constructor() {
      super();

      this.selectors = {
        sliderContainer: ".featured-slider__products",
        slideImages: ["featured-slider__img"],
        slideImagesContainer: ".featured-slider__images",
        sliderControls: ".sf-slider__controls",
        prevBtn: ".sf-slider__controls-prev",
        nextBtn: ".sf-slider__controls-next",
      };
      this.domNodes = queryDomNodes(this.selectors, this);
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      loadAssets(["swiper.css", "swiper.js"])
        .then(() => {
          const showNavigation = this.dataset.showNavigation === "true";
          const showPagination = this.dataset.showPagination === "true";
          const autoplay = this.dataset.autoplay === "true";
          const timeout = this.dataset.timeout;

          this.slider = new MinimogLibs.Swiper(this.domNodes.sliderContainer, {
            speed: 400,
            loop: false,
            autoplay: autoplay
              ? {
                  delay: parseInt(timeout),
                  disableOnInteraction: false,
                }
              : false,
            pagination: showPagination
              ? {
                  el: this.querySelector(".swiper-pagination"),
                  type: "bullets",
                  clickable: true,
                }
              : false,
            on: {
              init: () => {
                if (showNavigation) {
                  this.domNodes.prevBtn?.addEventListener("click", () => this.slider.slidePrev());
                  this.domNodes.nextBtn?.addEventListener("click", () => this.slider.slideNext());

                  this.domNodes.prevBtn.disabled = true;
                }

                // Calculate controls position
                if (this.dataset.container === "w-full") {
                  const firstItem = this.domNodes.sliderContainer.querySelector(".sf-image");
                  if (firstItem && this.domNodes.sliderControls) {
                    const itemHeight = firstItem.clientHeight;
                    const contentHeight = this.domNodes.sliderContainer.querySelector(
                      ".featured-slider__product-content"
                    )?.clientHeight;
                    this.domNodes.sliderControls.style.setProperty(
                      "--offset-top",
                      parseInt(itemHeight) / 2 + parseInt(contentHeight) + 24 + "px"
                    );
                  }
                }
              },
            },
          });

          // Sync 2 sliders
          this.imageSlider = new MinimogLibs.Swiper(this.domNodes.slideImagesContainer, {
            speed: 500,
            loop: false,
            effect: "fade",
            fadeEffect: {
              crossFade: true,
            },
          });

          this.slider.on("activeIndexChange", (swiper) => {
            const { activeIndex, isBeginning, isEnd } = swiper;
            this.imageSlider.slideTo(activeIndex);
            if (showNavigation) {
              this.domNodes.prevBtn.disabled = isBeginning;
              this.domNodes.nextBtn.disabled = isEnd;
            }
          });

          this.imageSlider.on("activeIndexChange", (swiper) => {
            const { activeIndex } = swiper;
            this.slider.slideTo(activeIndex);
          });
        })
        .catch(console.error);

      document.addEventListener("shopify:block:select", (e) => this.onBlockSelect(e));
    }

    onBlockSelect(evt) {
      const block = evt.target;
      const index = Number(block.dataset.index);
      this?.slider?.slideTo?.(index);
      this?.imageSlider?.slideTo?.(index);
    }
  }

  customElements.define("m-featured-slider", MFeaturedSlider);
}

if (!customElements.get("m-scrolling-promotion")) {
  class MScrollingPromotion extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.promotion = this.querySelector(".m-promotion");
      this.init();
    }

    init() {
      if (this.childElementCount === 1) {
        this.promotion.classList.add("m-promotion--animated");

        for (let index = 0; index < 10; index++) {
          this.clone = this.promotion.cloneNode(true);
          this.clone.setAttribute("aria-hidden", true);
          this.appendChild(this.clone);
        }

        // pause when out of view
        const observer = new IntersectionObserver(
          (entries, _observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.scrollingPlay();
              } else {
                this.scrollingPause();
              }
            });
          },
          { rootMargin: "0px 0px 50px 0px" }
        );

        observer.observe(this);
      }
    }

    scrollingPlay() {
      this.classList.remove("m-scrolling-promotion--paused");
    }

    scrollingPause() {
      this.classList.add("m-scrolling-promotion--paused");
    }
  }

  customElements.define("m-scrolling-promotion", MScrollingPromotion);
}

if (!customElements.get("m-featured-collection")) {
  class MFeaturedCollection extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        loadMoreBtn: "[data-load-more]",
        productsContainer: "[data-products-container]",
        products: [".sf__pcard"],
        soldNumber: ["[data-sold-number]"],
        availableNumber: ["[data-available-number]"],
        countDown: "[data-flashsale-countdown]",
        slideContainer: ".swiper-container",
      };
      this.domNodes = queryDomNodes(this.selectors, this);

      this.buttonType = this.dataset.buttonType;
      this.infiniteLoad = this.dataset.infiniteLoad;
      this.enableSlider = this.dataset.enableSlider === "true";
      this.showPagination = this.dataset.showPagination === "true";
      this.showNavigation = this.dataset.showNavigation === "true";
      this.enableFlashsale = this.dataset.enableFlashsale === "true";
      this.enableCountdown = this.dataset.enableCountdown === "true";
      this.id = this.dataset.id;
      this.items = this.dataset.items;

      if (this.enableSlider) this.initSlider();
      if (this.enableFlashsale) this.initFlashSale();

      this.canLoad = true;
      this.currentPage = 1;
      this.spinner = spinner();

      if (this.infiniteLoad === "true") this.initInfiniteLoad();
      if (this.buttonType === "load" && this.domNodes.loadMoreBtn) this.initLoadMore();
    }

    initSlider() {
      const controlsContainer = this.querySelector(".sf-slider__controls");
      const prevButton = controlsContainer && controlsContainer.querySelector(".sf-slider__controls-prev");
      const nextButton = controlsContainer && controlsContainer.querySelector(".sf-slider__controls-next");
      const slideItemsLength = this.domNodes.slideContainer.querySelector(".swiper-wrapper").childElementCount;
      const __this = this;

      loadAssets(["swiper.css", "swiper.js"]).then(() => {
        this.slider = new MinimogLibs.Swiper(this.domNodes.slideContainer, {
          slidesPerView: 2,
          showPagination: this.showPagination,
          showNavigation: this.showNavigation,
          loop: this.enableFlashsale ? false : true,
          pagination: this.showPagination
            ? {
                el: this.querySelector(".swiper-pagination"),
                clickable: true,
              }
            : false,
          breakpoints: {
            480: {
              slidesPerView: 3,
            },
            768: {
              slidesPerView: 4,
            },
            1280: {
              slidesPerView: parseInt(this.items),
              slidesPerGroup: 2,
            },
          },
          threshold: 2,
          on: {
            init: function () {
              setTimeout(() => {
                // Calculate controls position
                const firstItem = __this.querySelector(".sf-image");
                if (firstItem && controlsContainer) {
                  const itemHeight = firstItem.clientHeight;
                  controlsContainer.style.setProperty("--offset-top", parseInt(itemHeight) / 2 + "px");
                }
              }, 200);
            },
            breakpoint: (swiper, breakpointParams) => {
              if (controlsContainer) {
                const { slidesPerView } = breakpointParams;
                if (slideItemsLength > slidesPerView) {
                  controlsContainer.classList.remove("hidden");
                  swiper.allowTouchMove = true;
                } else {
                  controlsContainer.classList.add("hidden");
                  swiper.allowTouchMove = false;
                }
              }
            }
          },
        });

        if (this.slider && this.showNavigation) {
          prevButton && prevButton.addEventListener("click", () => this.slider.slidePrev());
          nextButton && nextButton.addEventListener("click", () => this.slider.slideNext());
        }
      });
    }

    initLoadMore() {
      this.triggerLoad = false;
      this.totalPages = parseInt(this.dataset.totalPages);

      addEventDelegate({
        context: this.container,
        selector: this.selectors.loadMoreBtn,
        handler: (e) => {
          e.preventDefault();
          this.handleLoadMore();
        },
      });
    }

    initInfiniteLoad() {
      const maxPages = this.dataset.maxPages;

      window.addEventListener("scroll", (e) => {
        this.canLoad = this.currentPage < parseInt(maxPages);

        if (!this.canLoad) return;
        if (this.offsetTop + this.clientHeight - window.innerHeight < window.scrollY && !this.triggerLoad) {
          this.triggerLoad = true;
          this.handleLoadMore();
        }
      });
    }

    async handleLoadMore() {
      this.currentPage++;
      this.canLoad = this.currentPage < this.totalPages;
      this.toggleLoading(true);
      const collectionID = this.dataset.collectionId;
      const res = await fetchCountDown(collectionID);

      const url = this.dataset.url;
      const dataUrl = `${url}?page=${this.currentPage}&section_id=${this.id}`;
      fetchCache(dataUrl).then((html) => {
        this.toggleLoading(false);
        const dom = generateDomFromString(html);
        const products = dom.querySelector(this.selectors.productsContainer);
        const oldCards = this.domNodes.productsContainer.childElementCount;
        let isAppended = false;

        if (products) {
          Array.from(products.childNodes).forEach((product) => {
            this.domNodes.productsContainer.appendChild(product);
            const check = setInterval(() => {
              if (this.domNodes.productsContainer.childElementCount > oldCards) {
                clearInterval(check);
                isAppended = true;
              }
            }, 50);
          });
        }

        if (this.enableFlashsale && res.ok && res.payload && res.payload.length) {
          const { expires_date } = res.payload[0];
          this.expires_date = expires_date;
          const check = setInterval(() => {
            if (isAppended) {
              clearInterval(check);
              const cards = this.domNodes.productsContainer.querySelectorAll(".sf__pcard");
              cards.forEach((card) => {
                const content = card.querySelector(".sf__pcard-content");
                const progress = card.querySelector(".pcard-sale");
                if (!progress) {
                  const soldNumber = card.dataset?.soldNumber;
                  const component = saleProgress(res.payload[0], card.dataset.productId, soldNumber);
                  const newComponent = generateDomFromString(component);
                  content.appendChild(newComponent);
                }
              });
            }
          }, 50);
        }

        this.triggerLoad = false;

        if (!this.canLoad) {
          this.domNodes.loadMoreBtn && this.domNodes.loadMoreBtn.classList.add("hidden");
        }
      });
    }

    toggleLoading(status) {
      if (!this.domNodes.loadMoreBtn) return;
      if (status) {
        this.newSpinner = generateDomeFromStringNew(this.spinner, "svg");
        this.domNodes.loadMoreBtn.appendChild(this.newSpinner);
        this.domNodes.loadMoreBtn.classList.add("sf-spinner-loading");
      } else {
        // this?.spinner?.remove()
        this.domNodes.loadMoreBtn.removeChild(this.newSpinner);
        this.domNodes.loadMoreBtn.classList.remove("sf-spinner-loading");
      }
    }

    async initFlashSale() {
      const collectionID = this.dataset.collectionId;
      const res = await fetchCountDown(collectionID);
      if (res.ok && res.payload && res.payload.length) {
        const { expires_date } = res.payload[0];
        this.expires_date = expires_date;
        this.domNodes.products.forEach((card) => {
          // const productForm = card.querySelector('.f-product-form')
          const content = card.querySelector(".sf__pcard-content");
          const soldNumber = card.dataset?.soldNumber;
          // const component = <SaleProgress settings={res.payload[0]} productId={card.dataset.productId} soldNumber={soldNumber} />
          const component = saleProgress(res.payload[0], card.dataset.productId, soldNumber);
          // const dom = new DOMParser().parseFromString(component, 'text/html')
          const newComponent = generateDomFromString(component);
          content.appendChild(newComponent);
        });
        this.initCountDown();
      }
    }

    initCountDown() {
      const endTime = new Date(this.expires_date).getTime();
      this.countDownTimer = new CountdownTimer(this.domNodes.countDown, Date.now(), endTime, {
        loop: true,
      });
    }
  }

  customElements.define("m-featured-collection", MFeaturedCollection);
}

if (!customElements.get("m-banner-with-slide")) {
  class MBannerWithSlide extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.lastActive = null;
      this.initSlider();
    }

    initSlider() {
      const paginationIcon = `<svg width="65px" height="65px" viewBox="0 0 72 72" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><circle class="time" stroke-width="5" fill="none" stroke-linecap="round" cx="33" cy="33" r="28"></circle></svg>`;
      loadAssets(["swiper.css", "swiper.js"]).then(() => {
        this.slider = new MinimogLibs.Swiper(`.sf-slider-${this.dataset.id}`, {
          autoplay:
            this.dataset.autoplay === "true" ? { delay: this.dataset.timeout, disableOnInteraction: true } : false,
          slidesPerView: 1,
          loop: true,
          fadeEffect: {
            crossFade: true,
          },
          pagination: {
            el: this.querySelector(".swiper-pagination"),
            clickable: true,
            bulletClass: "sf__dot",
            bulletActiveClass: "sf__dot-active",
            renderBullet: function (index, className) {
              return '<span class="' + className + '">' + paginationIcon + "</span>";
            },
          },
          on: {
            init: function () {
              this.slideToLoop(this.lastActive);
            },
          },
        });
      });
      document.addEventListener("shopify:block:select", (e) => this.onBlockSelect(e));
    }

    onBlockSelect(e) {
      const block = e.target;
      const index = Number(block.dataset.slide);
      this.lastActive = index;
      this.slider?.slideToLoop?.(index);
    }
  }

  customElements.define("m-banner-with-slide", MBannerWithSlide);
}

if (!customElements.get("m-brand-list")) {
  class MBrandList extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const enableSlider = this.dataset.enableSlider === "true";
      if (!enableSlider) return;
      const wrapper = this.querySelector("[data-wrapper]");
      const mediaQuery = window.matchMedia("(max-width: 1024px)");
      const handleChange = (e) => {
        if (e.matches) {
          this.initSlider();
          wrapper.classList.add("swiper-wrapper");
        } else {
          this.slider && this.slider.destroy(true, true);
          wrapper.classList.remove("swiper-wrapper");
        }
      };

      // Register event listener
      mediaQuery.addListener(handleChange);
      // Initial check
      handleChange(mediaQuery);
    }

    initSlider() {
      const autoplay = this.dataset.enableAutoplay === "true";
      const autoplaySpeed = this.dataset.autoplaySpeed;
      const items = parseInt(this.dataset.items);

      loadAssets(["swiper.css", "swiper.js"])
        .then(() => {
          this.slider = new MinimogLibs.Swiper(this.querySelector(".swiper-container"), {
            slidesPerView: items,
            slidesPerGroup: items,
            autoHeight: true,
            autoplay: autoplay
              ? {
                  delay: parseInt(autoplaySpeed) * 1000,
                }
              : false,
            loop: true,
            navigation: {
              nextEl: this.querySelector(".swiper-button-next"),
              prevEl: this.querySelector(".swiper-button-prev"),
            },
            pagination: {
              el: this.querySelector(".swiper-pagination"),
              clickable: true,
            },
          });
        })
        .catch(console.error());
    }
  }

  customElements.define("m-brand-list", MBrandList);
}

if (!customElements.get("m-custom-content")) {
  class MCustomContent extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        cdtContainer: [".countdown-timer-container"],
        bundleError: ".product-bundles__error",
        productBundles: [".product-bundles"],
        productVariantSelects: ".sf-product-variant-option-dropdown",
        totalPrice: "[data-total-price]",
        submitBundle: "[data-add-bundle]",
        errorWrapper: ".product-bundles__error",
      };

      this.domNodes = queryDomNodes(this.selectors, this);

      this.spinner = `<svg class='animate-spin hidden w-[20px] h-[20px] m-0.5' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
			<circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
			<path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
		  </svg>`;
    }

    connectedCallback() {
      this.initCountDown();
      if (this.domNodes.productBundles) this.initProductBundles();
    }

    initCountDown() {
      const countdowns = this.domNodes.cdtContainer;
      if (countdowns.length) {
        for (let countdown of countdowns) {
          const time = countdown.dataset.time;
          const endTime = Date.parse(time.split(" ").join("T"));
          if (endTime) {
            new CountdownTimer(countdown, Date.now(), endTime);
          }
        }
      }
    }

    initProductBundles() {
      this.products = [];
      this.variants = [];

      this.domNodes.productBundles.length &&
        this.domNodes.productBundles.map((bundle) => {
          const products = bundle.querySelectorAll(".product-bundles__item");

          for (let product of products) {
            let variants = product.nextElementSibling.innerHTML;
            variants = JSON.parse(variants);

            this.variants.push(variants);
            this.products.push(product);

            addEventDelegate({
              context: product,
              event: "change",
              selector: this.selectors.productVariantSelects,
              handler: (e) => this._handleChangePrice(e, product, variants),
            });
          }

          addEventDelegate({
            context: bundle,
            selector: this.selectors.submitBundle,
            handler: (e) => this._handleAddItems(e, bundle),
          });
        });
    }

    _handleChangePrice(evt, product, variants) {
      const regularPrice = product.querySelector("[data-regular-price]");
      const comparePrice = product.querySelector("[data-compare-price]");
      const savedPrice = product.querySelector("[data-saved-price]");

      const selectedVariant = evt.target.value;
      const variant = variants.find((v) => v.id === parseInt(selectedVariant));

      regularPrice.innerHTML = formatMoney(variant.price, MinimogSettings.money_format);
      regularPrice.dataset.price = variant.price;

      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        comparePrice?.classList.remove("hidden");
        savedPrice?.classList.remove("hidden");
        comparePrice.innerHTML = formatMoney(variant.compare_at_price, MinimogSettings.money_format);
        savedPrice.innerHTML = formatMoney(variant.compare_at_price - variant.price, MinimogSettings.money_format);
      } else {
        comparePrice?.classList.add("hidden");
        savedPrice?.classList.add("hidden");
      }

      // Calculate total price
      const selectedVariants = this.products
        .map((product) => {
          let variants = product.nextElementSibling.innerHTML;
          variants = JSON.parse(variants);

          const select = product.querySelector('[name="id"]');
          return variants?.find?.((v) => v?.id === Number(select?.value));
        })
        .filter(Boolean);

      const totalPrice = selectedVariants.reduce((s, v) => s + v.price, 0);
      const container = product.closest(".product-bundles");
      container.querySelector(this.selectors.totalPrice).innerHTML = formatMoney(
        totalPrice,
        MinimogSettings.money_format
      );
    }

    _handleAddItems(e, bundle) {
      e.preventDefault();
      const inputIds = bundle.querySelectorAll('[name="id"]');
      const errorWrapper = bundle.querySelector(this.selectors.errorWrapper);
      const button = bundle.querySelector(this.selectors.submitBundle);

      const ids = [...inputIds].map((input) => input.value);
      const data = { items: ids.map((id) => ({ id, quantity: 1 })) };

      const config = getRequestDefaultConfigs();
      config.method = "POST";
      config.body = JSON.stringify(data);

      this._toggleLoading(true, button);

      fetch("/cart/add.js", config)
        .then(async (res) => {
          if (!res?.ok) {
            const err = await res.json();
            this._showError(err?.description || "Failed to add all items to cart!", errorWrapper);
          } else {
            const { items } = await res.json();
            const firstItem = items.shift();
            window.Shopify.onItemAdded(firstItem);
            items.forEach((itm) => window.Shopify.onItemAdded(itm, false));
          }
          setTimeout(() => {
            this._toggleLoading(false, button);
          }, 300);
        })
        .catch((err) => {
          this._showError(err?.toString?.(), errorWrapper);
          this._toggleLoading(false, button);
        });
    }

    _showError(err, errorWrapper) {
      MinimogTheme.Notification.show({
        target: errorWrapper,
        method: "appendChild",
        type: "warning",
        message: err,
      });
    }
    _toggleLoading(loading, button) {
      if (loading) {
        button.insertAdjacentHTML("beforeend", this.spinner);
        button.classList.add("sf-spinner-loading");
      } else {
        const spinner = button.querySelector("svg.animate-spin");
        spinner?.remove();
        button.classList.remove("sf-spinner-loading");
      }
    }
  }

  customElements.define("m-custom-content", MCustomContent);
}

if (!customElements.get("m-hero")) {
  class MHero extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const bg = this.querySelector(".sf-hero__bg");
      if (!bg) return;

      if ("IntersectionObserver" in window) {
        this._initIntersectionObserver(bg);
      } else {
        this._initBackground(bg);
      }
    }

    _initIntersectionObserver(bg) {
      const _this = this;
      const rootMargin = "10px";
      const observer = new IntersectionObserver(
        (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          _this._initBackground(entries[0].target);
        },
        { rootMargin }
      );

      observer.observe(bg);
    }

    _initBackground(bg) {
      const src = bg.dataset.src;

      if (src) bg.style.backgroundImage = "url(" + src + ")";

      const parallaxEnabled = this.dataset.parallax === "true";

      if (parallaxEnabled && window.innerWidth > 767) {
        this._initParallax(bg);
      }
    }

    _initParallax(bg) {
      loadAssets("parallax.js")
        .then(() => {
          new MinimogLibs.simpleParallax(bg, {
            scale: 1.3,
            delay: 0.6,
            transition: "cubic-bezier(0,0,0,1)",
          });
        })
        .catch(console.error);
    }
  }

  customElements.define("m-hero", MHero);
}

if (!customElements.get("m-gmaps")) {
  class MGmaps extends HTMLElement {
    constructor() {
      super();
      this.mapElm = this.querySelector("#sf__map");
      this.mapAddress = this.mapElm.dataset.mapTitle;
      this.mapZoom = this.mapElm.dataset.mapZoom;
      this.mapX = this.mapElm.dataset.mapX;
      this.mapY = this.mapElm.dataset.mapY;
      this.key = this.mapElm.dataset.key;
      if (!this.mapElm.dataset.key) {
        return;
      }
    }

    connectedCallback() {
      this.prepMapApi();
    }

    prepMapApi() {
      this.loadScript().then(this.initMap.bind(this));
    }

    loadScript() {
      return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        document.body.appendChild(script);
        script.onload = resolve;
        script.onerror = reject;
        script.async = true;
        script.src = "https://maps.googleapis.com/maps/api/js?key=" + this.mapElm.dataset.key;
      });
    }

    initMap() {
      const geocoder = new google.maps.Geocoder();
      geocoder.geocode({ address: this.mapAddress }, (results, status) => {
        if (status !== google.maps.GeocoderStatus.OK) {
          if (Shopify.designMode) {
          }
        } else {
          const mapOptions = {
            zoom: parseInt(this.mapZoom),
            center: new google.maps.LatLng(this.mapX, this.mapY),
            draggable: true,
            clickableIcons: false,
            scrollwheel: false,
            disableDoubleClickZoom: true,
            disableDefaultUI: true,
            styles: [
              { featureType: "water", elementType: "geometry", stylers: [{ color: "#e9e9e9" }, { lightness: 17 }] },
              { featureType: "landscape", elementType: "geometry", stylers: [{ color: "#f5f5f5" }, { lightness: 20 }] },
              {
                featureType: "road.highway",
                elementType: "geometry.fill",
                stylers: [{ color: "#ffffff" }, { lightness: 17 }],
              },
              {
                featureType: "road.highway",
                elementType: "geometry.stroke",
                stylers: [{ color: "#ffffff" }, { lightness: 29 }, { weight: 0.2 }],
              },
              {
                featureType: "road.arterial",
                elementType: "geometry",
                stylers: [{ color: "#ffffff" }, { lightness: 18 }],
              },
              {
                featureType: "road.local",
                elementType: "geometry",
                stylers: [{ color: "#ffffff" }, { lightness: 16 }],
              },
              { featureType: "poi", elementType: "geometry", stylers: [{ color: "#f5f5f5" }, { lightness: 21 }] },
              { featureType: "poi.park", elementType: "geometry", stylers: [{ color: "#dedede" }, { lightness: 21 }] },
              {
                elementType: "labels.text.stroke",
                stylers: [{ visibility: "on" }, { color: "#ffffff" }, { lightness: 16 }],
              },
              {
                elementType: "labels.text.fill",
                stylers: [{ saturation: 36 }, { color: "#333333" }, { lightness: 40 }],
              },
              { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
              { featureType: "transit", elementType: "geometry", stylers: [{ color: "#f2f2f2" }, { lightness: 19 }] },
              {
                featureType: "administrative",
                elementType: "geometry.fill",
                stylers: [{ color: "#fefefe" }, { lightness: 20 }],
              },
              {
                featureType: "administrative",
                elementType: "geometry.stroke",
                stylers: [{ color: "#fefefe" }, { lightness: 17 }, { weight: 1.2 }],
              },
            ],
          };
          const map = new google.maps.Map(this.mapElm, mapOptions);
          new google.maps.Marker({
            map: map,
            position: new google.maps.LatLng(this.mapX, this.mapY),
            title: this.mapAddress,
          });

          google.maps.event.addDomListener(window, "resize", function () {
            google.maps.event.trigger(map, "resize");
          });
        }
      });
    }
  }

  customElements.define("m-gmaps", MGmaps);
}

if (!customElements.get("m-countdown-timer")) {
  if (!customElements.get("m-countdown-timer")) {
    class MCountdownTimer extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        const time = this.dataset.time;
        const endTime = Date.parse(time.split(" ").join("T"));
        if (endTime) {
          new CountdownTimer(this, Date.now(), endTime);
        }
      }
    }

    customElements.define("m-countdown-timer", MCountdownTimer);
  }
}

if (!customElements.get('m-image-comparison')) {
  class MImageComparison extends HTMLElement {
    constructor() {
      super()
      this.active = false;
      this.button = this.querySelector('button');
      this.horizontal = this.dataset.layout === 'horizontal';
      this.init();
    }

    init() {
      this.button.addEventListener('touchstart', this.start.bind(this));
      document.body.addEventListener('touchend', this.end.bind(this));
      document.body.addEventListener('touchmove', this.onStart.bind(this));

      this.button.addEventListener('mousedown', this.start.bind(this));
      document.body.addEventListener('mouseup', this.end.bind(this));
      document.body.addEventListener('mousemove', this.onStart.bind(this));
    }

    start() {
      document.documentElement.style.setProperty('overflow', 'hidden')
      this.active = true;
      this.classList.add('image-comparing');
    }

    end() {
      document.documentElement.style.removeProperty('overflow')
      this.active = false;
      this.classList.remove('image-comparing');
    }

    onStart(e) {
      const topbar = document.querySelector('.sf-topbar');
      const announcement = document.querySelector('.announcement-bar');
      let topbarHeight = 0, announcementHeight = 0;
      if (topbar) {
        topbarHeight = topbar.offsetHeight
      }
      if (announcement) {
        announcementHeight = announcement.offsetHeight
      }
      if (!this.active) return;

      const event = (e.touches && e.touches[0]) || e;
      const x = this.horizontal
        ? event.pageX - this.offsetLeft
        : event.pageY - this.offsetTop - topbarHeight - announcementHeight;

      this.scroll(x);
    }

    scroll(x) {
      const distance = this.horizontal ? this.clientWidth : this.clientHeight;
      const max = distance - 20;
      const min = 20;
      const mouseX = Math.max(min, (Math.min(x, max)));
      const mousePercent = (mouseX * 100) / distance;
      this.style.setProperty('--percent', mousePercent + '%');
    }
  }
  customElements.define('m-image-comparison', MImageComparison)
}

if (!customElements.get('m-video-component')) {
  class VideoComponent extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
    }

    init() {
      this.parentSelector = this.dataset.parent || ".sf-hero__bg";
      this.parent = this.closest(this.parentSelector);

      switch (this.dataset.type) {
        case "youtube":
          this.initYoutubeVideo();
          break;

        case "vimeo":
          this.initVimeoVideo();
          break;

        case "mp4":
          this.initMp4Video();
          break;
      }
    }

    initYoutubeVideo() {
      console.log('init youtube video')
      this.setAsLoading();
      this.loadScript("youtube").then(this.setupYoutubePlayer.bind(this));
    }

    initVimeoVideo() {
      this.setAsLoading();
      this.loadScript("vimeo").then(this.setupVimeoPlayer.bind(this));
    }

    initMp4Video() {
      const player = this.querySelector("video");

      if (player) {
        const promise = player.play();

        // Edge does not return a promise (video still plays)
        if (typeof promise !== "undefined") {
          promise
            .then(function () {
              // playback normal
            })
            .catch(function () {
              player.setAttribute("controls", "");
            });
        }
      }
    }

    loadScript(videoType) {
      return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        document.body.appendChild(script);
        script.onload = resolve;
        script.onerror = reject;
        script.async = true;
        script.src =
          videoType === "youtube"
            ? "//www.youtube.com/iframe_api"
            : "//player.vimeo.com/api/player.js";
      });
    }

    setAsLoading() {
      this.parent.setAttribute("loading", true);
    }

    setAsLoaded() {
      this.parent.removeAttribute("loading");
      this.parent.setAttribute("loaded", true);
    }

    setupYoutubePlayer() {
      const videoId = this.dataset.videoId;
      const playerInterval = setInterval(() => {
        if (window.YT) {
          window.YT.ready(() => {
            const element = document.createElement("div");
            this.appendChild(element);

            this.player = new YT.Player(element, {
              videoId: videoId,
              playerVars: {
                showinfo: 0,
                controls: false,
                fs: 0,
                rel: 0,
                height: "100%",
                width: "100%",
                iv_load_policy: 3,
                html5: 1,
                loop: 1,
                playsinline: 1,
                modestbranding: 1,
                disablekb: 1,
              },
              events: {
                onReady: this.onYoutubeReady.bind(this),
                onStateChange: this.onYoutubeStateChange.bind(this),
              },
            });
            clearInterval(playerInterval);
          });
        }
      }, 50);
    }

    onYoutubeReady() {
      this.iframe = this.querySelector("iframe"); // iframe once YT loads
      this.iframe.setAttribute("tabindex", "-1");

      this.player.mute();
      if (typeof this.player.playVideo === 'function') this.player.playVideo();

      this.setAsLoaded();

      // pause when out of view
      const observer = new IntersectionObserver(
        (entries, _observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.youtubePlay();
            } else {
              this.youtubePause();
            }
          });
        },
        { rootMargin: "0px 0px 50px 0px" }
      );

      observer.observe(this.iframe);
    }

    onYoutubeStateChange(event) {
      switch (event.data) {
        case -1: // unstarted
          // Handle low power state on iOS by checking if
          // video is reset to unplayed after attempting to buffer
          if (this.attemptedToPlay) {
            this.setAsLoaded();
            // this.closest('.banner').classList.add('video-interactable');
          }
          break;
        case 0: // ended, loop it
          this.youtubePlay();
          break;
        case 1: // playing
          this.setAsLoaded();
          break;
        case 3: // buffering
          this.attemptedToPlay = true;
          break;
      }
    }

    youtubePlay() {
      if (this.player && typeof this.player.playVideo === "function") {
        this.player.playVideo();
      }
    }

    youtubePause() {
      if (this.player && typeof this.player.pauseVideo === "function") {
        this.player.pauseVideo();
      }
    }

    setupVimeoPlayer() {
      const videoId = this.dataset.videoId;

      const playerInterval = setInterval(() => {
        if (window.Vimeo) {
          this.player = new Vimeo.Player(this, {
            id: videoId,
            autoplay: true,
            autopause: false,
            background: false,
            controls: false,
            loop: true,
            height: "100%",
            width: "100%",
          });
          this.player.ready().then(this.onVimeoReady.bind(this));
          clearInterval(playerInterval);
        }
      }, 50);
    }

    onVimeoReady() {
      this.iframe = this.querySelector("iframe");
      this.iframe.setAttribute("tabindex", "-1");

      this.player.setMuted(true);

      this.setAsLoaded();

      // pause when out of view
      const observer = new IntersectionObserver(
        (entries, _observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.vimeoPlay();
            } else {
              this.vimeoPause();
            }
          });
        },
        { rootMargin: "0px 0px 50px 0px" }
      );

      observer.observe(this.iframe);
    }

    vimeoPlay() {
      if (this.player && typeof this.player.play === "function") {
        this.player.play();
      }
    }

    vimeoPause() {
      if (this.player && typeof this.player.pause === "function") {
        this.player.pause();
      }
    }
  }
  customElements.define("m-video-component", VideoComponent);
}

if (!customElements.get('m-search-popup')) {
  class MSearchPopup extends HTMLElement {
    constructor() {
      super()

      this.selectors = {
        container: '[data-search-container]',
        form: 'form',
        input: '[data-search-input]',
        submit: 'button[type="submit"]',
        loading: '[data-spinner]',
        close: '[data-close-search]',
      }

      const searchPopup = document.querySelector('[data-search-popup]')
      if (!searchPopup) return

      this.domNodes = queryDomNodes(this.selectors, searchPopup)
      this.domNodes.searchPopup = searchPopup
      document.body.appendChild(searchPopup)
      addEventDelegate({
        selector: '[data-open-search-popup]',
        handler: () => this.toggleSearchPopup(true)
      })

      const { input, submit, close, form } = this.domNodes
      input?.addEventListener('keydown', (e) => {
        // ESC
        if (e.keyCode === 27) {
          this.toggleSearchPopup(false)
        }
      })
      submit.addEventListener('click', e => {
        e.preventDefault()
        if (input.value) {
          form.submit()
        }
      })
      close.addEventListener('click', e => {
        this.toggleSearchPopup(false)
      })
      searchPopup.addEventListener('click', e => {
        if (e.target === searchPopup) {
          this.toggleSearchPopup(false)
        }
      })
    }

    toggleSearchPopup(show) {
      const { searchPopup, input, container } = this.domNodes
      if (show) {
        searchPopup.classList.remove('invisible')
        searchPopup.classList.add('opacity-100')
        container.classList.add('md:translate-y-0')
        setTimeout(() => {
          container.classList.remove('duration-300')
        }, 350)
        input.focus()
      } else {
        container.classList.remove('md:translate-y-0')
        searchPopup.classList.remove('opacity-100')
        setTimeout(() => {
          searchPopup.classList.add('invisible')
          container.classList.add('duration-300')
        }, 350)
      }
    }
  }

  customElements.define('m-search-popup', MSearchPopup)
}
